export default __webpack_public_path__ + "static/media/logo.0ac3086f.svg";